"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healthCheck = void 0;
exports.healthCheck = {
    heading: "Drivers Health Check",
    "n/a": "N/A",
    buttons: {
        details: "Details",
        refresh: "Refresh",
        close: "Close",
    },
    toasts: {
        copiedToClipboard: "Copied to clipboard",
    },
};
